"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NODES_CONTAINER = exports.FIRST_NODE = exports.BTN_SET_PERMISSION = exports.BTN_MORE = exports.DESCRIPTION = exports.TITLE_INPUT = exports.TITLE = void 0;
/* eslint-disable */
// folder preview
const FOLDER_SHOWCASE_PREFIX = 'FOLDER_SHOWCASE_';
exports.TITLE = FOLDER_SHOWCASE_PREFIX + 'TITLE'; // title
exports.TITLE_INPUT = FOLDER_SHOWCASE_PREFIX + 'TITLE_INPUT'; // Title in the form of an input box
exports.DESCRIPTION = FOLDER_SHOWCASE_PREFIX + 'DESCRIPTION'; // description
exports.BTN_MORE = FOLDER_SHOWCASE_PREFIX + 'BTN_MORE'; // more button
exports.BTN_SET_PERMISSION = FOLDER_SHOWCASE_PREFIX + 'BTN_SET_PERMISSION'; // Set permissions button under more button
exports.FIRST_NODE = FOLDER_SHOWCASE_PREFIX + 'FIRST_NODE'; // the first node of the folder preview page
exports.NODES_CONTAINER = FOLDER_SHOWCASE_PREFIX + 'NODES_CONTAINER'; // parent container of child nodes
//# sourceMappingURL=folder_showcase_id.js.map